import { Component, DestroyRef, HostBinding, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { selectMainMenuExpanded } from '../../reducers';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrl: './analytics.component.scss',
    standalone: false
})
export class AnalyticsComponent {
  mainMenuExpanded: boolean = false;

  private destroyRef = inject(DestroyRef);

  constructor(private store: Store<AppState>) {
    this.store
      .select(selectMainMenuExpanded)
      .pipe(
        tap((expanded) => {
          this.mainMenuExpanded = expanded;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  @HostBinding('style.width') get width() {
    const mainMenuOffset = this.mainMenuExpanded ? px2Rem(220) : px2Rem(60);
    return 'calc(100% - ' + `${mainMenuOffset}rem)`;
  }
}
